export default {
  GENERAL_NAVIGATION_STEP_CHECKER: 'GENERAL_NAVIGATION_STEP_CHECKER',
  TOPVIEW_NAVIGATION_STEP_CHECKER: 'TOPVIEW_NAVIGATION_STEP_CHECKER',
  NEIGHBOURHOOD_SECTION_NAVIGATION_STEP_CHECKER:
    'NEIGHBOURHOOD_SECTION_NAVIGATION_STEP_CHECKER',
}
